import axios from 'axios';
import config from '../../config/config';
import {
    TOGGLE_UPLOAD_OPTIONS,
    TOGGLE_LINK_SLIDER,
    UPLOAD_YOUTUBE_VIDEO,
    UPLOAD_IMAGE_FROM_LINK,
    TOGGLE_COPY_SLIDER,
    UPLOAD_IMAGE_FROM_ADD_EDIT,
    UPLOAD_YOUTUBE_VIDEO_FROM_ADD_EDIT,
    TOGGLE_SEARCH_IMAGE
} from './types';
import {setSession} from './index';
import { getImagePath, updateProductMediaService } from '../common/productImageUtils';
import { getJdMartParams } from '../../client/utills';
const apiDomain = config.apiDomains[0];

export const toggleUploadOptions = payload => ({
    type: TOGGLE_UPLOAD_OPTIONS,
    payload
});

export const toggleLinkSlider = payload => ({
    type: TOGGLE_LINK_SLIDER,
    payload
});

export const toggleCopySlider = payload => ({
    type: TOGGLE_COPY_SLIDER,
    payload
})

export const toggleSearchImage = payload => ({
    type: TOGGLE_SEARCH_IMAGE,
    payload
})

export const uploadYoutubeLink = (payload, cb) => (dispatch, getState) => {
    const {
        uploadOptions: {
            data,
            productId
        },
        session: {
            token,
            videoExists,
            user,
            viaOmni=false,
            supplierId=''
        }
    } = getState();

    const isEnrich = user?.loggedUser?.subType=='CONTRACTORV4';

    /* if(!payload.ignoreSave){
        await linkUnlinkVideoRequest({
            variantId: payload.variantId,
            videoId: data.videoId
        }, token);
    } */
    let omniParams = viaOmni ? `&isFromVendorModule=true&supplierId=${supplierId}` : '';
    let url = `${apiDomain}/marketplace/static/php/web/b2bWebsite.php?&action=addYouTubeVideoData&token=${token}${omniParams}&youtubeUrl=${encodeURI(payload.link)}`;
    if (isEnrich) {
        url = `${apiDomain}/marketplace/static/php/web/b2bWebsite.php?action=addYoutubeVideoEnrich&token=${token}&youtubeUrl=${encodeURI(payload.link)}&forEnrich=true`;
    }
    let jdMartParams = getJdMartParams();
    url += `&sourceId=${jdMartParams.sourceId ? jdMartParams.sourceId : ''}`;
    if(productId != 'ADD_PRODUCT') {
        url += `&productId=${productId}`;
    }

    axios.get(url).then(response => {
        if(response.status != 200 || response.data.status != 1) {
            return cb(false);//ERROR
        }

        const {
            status,
            videoData='',
            ...videoObj
        } = response.data;

        // videoName: "Why Ventilators are important? Shortage of Ventilators in India and World, Current Affairs 2020"
        // status: "UNDER_REVIEW"
        // source: "YOUTUBE"
        // imgURL: "https://youtu.be/9qwCfWxvL5s"
        // thumbnailURL: "https://i.ytimg.com/vi/9qwCfWxvL5s/default.jpg"
        // uploaded: true
        // isVideo: true
        // actualPath: "/
        let parsedVideoData = {};
        try {
            parsedVideoData = JSON.parse(videoData)
        } catch(e) {}
        if(payload.onFileUpload){
            payload.onFileUpload({
                forVideo: true,
                imageUrl: {
                    videoName: videoObj.videoName,
                    status: "UNDER_REVIEW",
                    source: "YOUTUBE",
                    imgURL: parsedVideoData.imgURL,
                    thumbnailURL: parsedVideoData.thumbnailURL,
                    uploaded: true,
                    isVideo: true,
                    actualPath: payload.link,
                    videoId: videoObj.videoId
                }
            })
        }else{
            (payload.isAddProductPage || payload.isEnrichProductPage) ?
            dispatch({
                type: UPLOAD_YOUTUBE_VIDEO_FROM_ADD_EDIT,
                payload: {
                    ...videoObj,
                    ...parsedVideoData,
                    link: payload.link,
                    productId: productId
                }
            })
            : dispatch({
                type: UPLOAD_YOUTUBE_VIDEO,
                payload: {
                    ...videoObj,
                    ...parsedVideoData,
                    link: payload.link,
                    productId: productId
                }
            });
        }

        if(!videoExists) {
            dispatch(setSession({
                videoExists: true
            }));
        }

        cb && cb(true);
    })
};

export const uploadImageFromLink = (payload, cb) => (dispatch, getState) => {
    const {link=""} = payload;
    const regEx = /tradeindia|amazon|modid|zoomImage|indiamart|imimg|alicdn|udaan|ud-img|tiimg|tistatic|flipkart|flixcart/g;

    let {
        uploadOptions: {
            data
        },
        session: {
            token,
            supplierId,
            source,
            user,
            isOnboardingEmp,
            viaOmni
        },
        products: {
            allProducts,
            editProduct
        }
    } = getState();
    const mathedKEywords = link.match(regEx);
    if(mathedKEywords && token){
        return cb(false,`Use of Image's from ${mathedKEywords[0]} is prohibited`)
    }

    const isEnrich = user?.loggedUser?.subType=='CONTRACTORV4';
    const isContractorV2 = user.loggedUser && ["CONTRACTORV2"].indexOf(user.loggedUser.subType) != -1;
    data = !Object.keys(data).length && payload.productId == 'FILE_MODULE' ? {productId : 'FILE_MODULE',ignoreSave: true} : data; 
    const prodId = data.productId
    const prodName = editProduct?.productName ? editProduct?.productName : allProducts[data.productId]?.productName || ""
    let queryParams = `module=product&imageUrl=${encodeURI(payload.link)}`
    if(supplierId){
        queryParams += `&supplierId=${supplierId}`
    }
    if(prodId != "ADD_PRODUCT"){
        queryParams += `&product_id=${prodId}`
    }
    if(prodName){
        queryParams += `&product_name=${prodName}`
    }
    if(isContractorV2 || isOnboardingEmp){
        queryParams += `&usertype=CONTRACTORV2`
    }
    let url = `${apiDomain}/vendorapis/products/product/uploadImageThroughUrl?${queryParams}`
    // below url is old image upload url current not using keep it commented for future reference
    // let url = `${apiDomain}/marketplace/products/php/ajax/uploadProductImageThroughUrl.service?imageUrl=${encodeURI(payload.link)}&module=product&supplierId=${supplierId}`+(isContractorV2 || isOnboardingEmp?`&usertype=CONTRACTORV2`:``);
    // ignoring this for new image api bcoz contractorV4 is not come
    if(isEnrich){
        url = `${apiDomain}/marketplace/products/php/ajax/uploadProductImageThroughUrl.service?imageUrl=${encodeURI(payload.link)}&module=product&forDc=1`
    }
    axios.get(url).then(response => {
        if(response.status != 200 || response.data.isError === "true") {
            return cb(false, response.data.message);//ERROR
        }

        const {
            imgURL
        } = response.data;

        if(payload.onFileUpload) {
            if(payload.fromViewImageSlider){
                payload.onFileUpload({
                    createdfrom: 'url',
                    uploadType: 'MULTIPLE',
                    imageUrlObj: {
                        imgURL,
                        actualPath: getImagePath(imgURL),
                        uploaded: true
                    },
                    productId: data.productId
                })
            } else{
                payload.onFileUpload({
                    forVideo: false,
                    createdfrom: 'url',
                    imgURL,
                    imageUrl: imgURL
                });
            }

            cb && cb(true);
            return ;
        }

        ((payload.isAddProductPage || payload.isEnrichProductPage || (viaOmni && payload.isAddProductPageOmni))) ? dispatch({
            type: UPLOAD_IMAGE_FROM_ADD_EDIT,
            payload: {
                uploadType: 'MULTIPLE',
                imageUrlObj: {
                    imgURL,
                    actualPath: getImagePath(imgURL),
                    uploaded: true
                },
                productId: data.productId
            }
        }) : dispatch({
            type: UPLOAD_IMAGE_FROM_LINK,
            payload: {
                imageUrlObj: {
                    imgURL,
                    actualPath: getImagePath(imgURL),
                    uploaded: true,
                    link: payload.link
                },
                productId: data.productId || payload.productId,
                viaOmni
            }
        });

        let uploadRequest = true;
        if(data.ignoreSave || data.productId === 'ADD_PRODUCT'){
            uploadRequest = false;
        }

        if(uploadRequest){
            const { imageUrlArr } = allProducts[data.productId];
            const finalImageUrl = [];
            imageUrlArr.map((imgObj) => {
                if (imgObj.uploaded) {
                    finalImageUrl.push(imgObj.imgURL);
                }
            })
            updateProductMediaService({
                productId: data.productId,
                imageUrl: finalImageUrl.join(','),
                videoUrl: JSON.stringify({}),
                source
            });
        }
        cb && cb(true); //SUCCESS
    })
};